//到款信息管理
import {contractApi} from "@/axios";
//获取到款信息
export function getPaymentPage(params,sendData){
    return contractApi({
        url:'/payment-info/page',
        method:'post',
        data:sendData,
        params:params
    })
}
//删除到款信息
export function deletePayment(params){
    return contractApi({
        url:'/payment-info',
        method:'delete',
        params:params
    })
}
//添加到款信息
export function addPayment(data){
    return contractApi({
        url:'/payment-info',
        method:'post',
        data:data
    })
}
//修改到款信息
export function editPayment(data){
    return contractApi({
        url:'/payment-info',
        method:'put',
        data:data
    })
}
//到款信息认领
export function claimInvoice(data){
    return contractApi({
        url:'/payment-info/claim-invoice',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}